import { defineComponent as _defineComponent } from 'vue'
type vClaimsModalProps = {
  showEnabledClaims: boolean;
  enabledClaims : string[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vEnabledClaimsList',
  props: {
    showEnabledClaims: { type: Boolean, default: false },
    enabledClaims: null
  },
  setup(__props: any) {

const props = __props as { showEnabledClaims: boolean, enabledClaims : string[] };





return { __sfc: true,props }
}

})